import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';
import { CardType, COBRAND_CARD_TYPE } from '../constants';

type CardItem = {
  cardType?: CardType;
  cardname?: string;
  imagePath?: string;
  header?: string;
  checked?: boolean;
};

type CobrandData = {
  activeTabValue?: CardType;
  selectedCards: CardItem[];
  allCarouselCards: CardItem[];
};

export type CobrandStore = {
  cobrandData: CobrandData;
  setCobrandData: (data: CobrandData) => void;
};

const initialState: CobrandStore = {
  cobrandData: {
    activeTabValue: COBRAND_CARD_TYPE.PERSONAL,
    selectedCards: [],
    allCarouselCards: [],
  },
  setCobrandData: () => null,
};

const CobrandStore: StateCreator<CobrandStore> = set => {
  return {
    ...initialState,
    setCobrandData: data => {
      set({
        cobrandData: { ...data },
      });
    },
  };
};

export const useStore = createAppStore(CobrandStore, {
  usePersistentStore: false,
});
